import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { AccountClearCookiesComponent } from '@layout/account-clear-cookies/account-clear-cookies.component';
import { UnauthorizedPageComponent } from '@layout/unauthorized-page/unauthorized-page.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'order-harness',
        pathMatch: 'full',
    },
    {
        path: 'order-harness',
        loadChildren: () => import('./features/order-harness/order-harness.module').then(m => m.OrderHarnessModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'Account/ClearCookies',
        component: AccountClearCookiesComponent,
    },
    {
        path: 'unauthorized',
        component: UnauthorizedPageComponent,
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
